module.exports = __webpack_public_path__ + "assets/img/small_oral_liquid_icon.261e0875.svg";